import Images from "../../../specific/utils/Images";

const images: Images = new Images();

export const getImageSource = (sources: {app_image?: string; img_url?: string}): {uri: string} | number => {
    const { app_image, img_url } = sources;

    if ((app_image !== undefined) && (images[app_image] !== undefined)) {
        return images[app_image];
    } else if (img_url !== undefined) {
        return {uri: img_url};
    }
    return {uri: "ic_lili_circle"};
}